import fetch from './http'


let baseURL = '',baseURL2 = '';
if (process.env.NODE_PM === 'prod') {
    baseURL = 'https://app.aigupiao.com';
    baseURL2 = 'https://mobile.aigupiao.com';
} else if (process.env.NODE_PM === 'dev') {
    baseURL = 'https://appdev.aigupiao.com';
    baseURL2 = 'https://mobiledev.aigupiao.com';
} else if (process.env.NODE_PM === 'beta') {
    baseURL = 'https://appbeta.aigupiao.com';
    baseURL2 = 'https://mobilebeta.aigupiao.com'; 
}


// 邀请人信息
export const info = args => fetch({
    url: baseURL2 + '/referring/invitation',
    method: 'get',
    params: args.params,
});
//发送验证码
export const code = args => fetch({
    url: baseURL + '/v1/affiliate/refer/verifyCode',
    method: 'post',
    params: args.params,
});
//手机号验证码登录
export const phoneLogin = args => fetch({
    url: baseURL2+'/referring/registerByPhone',
    method: 'get',
    params: args.params,
});
//微信授权登录
export const wechatLogin = args => fetch({
    url: baseURL2+'/referring/registerByWechat',
    method: 'get',
    params: args.params,
});